import { ChangeEvent, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { venueService } from "services/venueService";
import { store } from "store";
import { successAlert } from "utils/alertHandler";
import { useTranslation } from "react-i18next";
import { sleep } from "utils/dateUtil";

const { REACT_APP_DEFAULT_VENUE_ID } = process.env;

export default function usePayDone() {
  const [bookingInfo, setBookingInfo] = useState<any>();

  const inputRef = useRef<any>();

  const { t } = useTranslation();

  const [isUploadingPayment, setIsUploadingPayment] = useState<boolean>(false);
  const [isPaymentUploaded, setIsPaymentUploaded] = useState<boolean>();

  const location = useLocation();

  const navigate = useNavigate();
  const { venue_booking_id, totalHours } = location.state;

  useEffect(() => {
    (async () => {
      try {
        if (!venue_booking_id) return;

        const bookings = await venueService.getVenueBookingsByVenueIdAndUserId(Number(REACT_APP_DEFAULT_VENUE_ID), {
          filter: `[vb.venue_booking_id:eq:${venue_booking_id}]`,
        });

        if (!bookings || bookings.length < 1) return;

        await sleep(1000);

        const booking = bookings[0];

        setIsPaymentUploaded(booking.payment_proof_url != null);
        setBookingInfo(booking);
      } catch (error) {
        // console.log("Error : ", error);
      }
    })();
  }, []);

  if (!location.state) {
    navigate("/");
    return <></>;
  }

  const _onPaymentUpload = async (e: ChangeEvent<HTMLInputElement>) => {
    try {
      if (!e.target.files) return;

      const user_id = store.getState()!["auth"]["user"]!["user_id"];

      setIsUploadingPayment(true);

      const result = await venueService.uploadVenueBookingPaymentReceipt(
        {
          venue_booking_id: venue_booking_id,
          venue_id: Number(REACT_APP_DEFAULT_VENUE_ID),
          user_id: Number(user_id),
        },
        e.target.files[0]
      );

      setIsUploadingPayment(false);

      if (!result) return;

      successAlert(t("profile_upload_receipt_success"));

      setIsPaymentUploaded(true);
    } catch (error: any) {
      successAlert(t("profile_upload_receipt_fail"));
      setIsUploadingPayment(false);
    }
  };

  return {
    inputRef,
    totalHours,
    bookingInfo,
    isUploadingPayment,
    isPaymentUploaded,
    _onPaymentUpload,
  };
}
